import { createActionFactory } from '../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Experience Workspace => theme => ');

//WARNING: will stack existing theme list with new values; does not clean up old themes from the store
const fetchThemes = createAction('fetch themes', (formatType, containerRef, params) => ({
  formatType,
  containerRef,
  params,
}));
const fetchThemesFailure = createApiFailureAction('fetch themes failure');
const fetchThemesSuccess = createAction('fetch themes success', (themes) => ({ themes }));

const fetchTheme = createAction('fetch theme');
const fetchThemeFailure = createApiFailureAction('fetch theme failure');
const fetchThemeSuccess = createAction('fetch theme success', (theme) => ({ theme }));

const clearThemes = createAction('clear themes');

//this action bypasses the merge and explicitly sets the list of all themes to the new value, rather than stacking the list
const setThemeList = createAction('set theme list', (themes) => ({ themes }));

export default {
  fetchThemes,
  fetchThemesFailure,
  fetchThemesSuccess,
  fetchTheme,
  fetchThemeFailure,
  fetchThemeSuccess,
  clearThemes,
  setThemeList,
};
